import {OrderSheetProductsState} from '../interfaces'

export const getInitialState = (): OrderSheetProductsState => []
